import { useState } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import Toggle from '../form/Toggle'
import SocialSettingsModal from './SocialSettingsModal'
import { ReactComponent as ShieldIcon } from '../../../assets/images/common/icons/shield-check-mark.svg'
import { ReactComponent as QuestionIcon } from '../../../assets/images/common/icons/question-mark-circle.svg'

import classes from './ChildSocialFeatureSettings.module.scss'

const ChildSocialFeatureSettings = ({
  allowPostingContent,
  allowPostingComments,
  onChangePostingContent,
  onChangePostingComments,
  stacked,
}) => {
  const [showHelpModal, setShowHelpModal] = useState(false)

  const columnClass = stacked ? 'col-12' : 'col-12 col-md-6'

  return (
    <div className={classes.toggleWrapper}>
      <div className='d-flex align-items-center mb-5'>
        <ShieldIcon className={classes.shieldIcon} aria-hidden='true' />
        <h4 className={classNames(classes.title, 'font-weight-bold mb-0 mx-2')}>Child Social Feature Settings</h4>
        <button type='button' className={classes.helpButton} onClick={() => setShowHelpModal(true)} aria-label='About child social feature settings'>
          <QuestionIcon className={classes.helpIcon} aria-hidden='true' />
        </button>
      </div>

      <div className='row'>
        <div className={classNames(columnClass, 'mb-4')}>
          <div className='d-flex align-items-start'>
            <Toggle
              size='small'
              id='allowPostingContent'
              checked={allowPostingContent}
              onChange={e => onChangePostingContent(e.target.checked)}
            />
            <label htmlFor='allowPostingContent' className={classNames(classes.toggleTitle, 'font-weight-bold mb-0 ml-3')}>
              Allow your student to include Images &amp; Description on their golf activities.
            </label>
          </div>
          <p className={classNames(classes.toggleDescription, 'mt-3')}>
            When making a post, you have the option to add a picture and description to your activity.
            Turn this off to remove this feature. Note - If turned off you as a parent cannot log a picture or description as well.
          </p>
        </div>

        <div className={classNames(columnClass, 'mb-4')}>
          <div className='d-flex align-items-start'>
            <Toggle
              size='small'
              id='allowPostingComments'
              checked={allowPostingComments}
              onChange={e => onChangePostingComments(e.target.checked)}
            />
            <label htmlFor='allowPostingComments' className={classNames(classes.toggleTitle, 'font-weight-bold mb-0 ml-3')}>
              Allow Commenting on Posts
            </label>
          </div>
          <p className={classNames(classes.toggleDescription, 'mt-3')}>
            You will be able to see activities logged by other participants at your facility in the community feed.
            By turning this off your junior account will not be able to log comments on others posts.
            Note - If turned off you as a parent cannot log a comment on their behalf.
          </p>
        </div>
      </div>

      <SocialSettingsModal showModal={showHelpModal} closeModal={() => setShowHelpModal(false)} />
    </div>
  )
}

ChildSocialFeatureSettings.propTypes = {
  allowPostingContent: PropTypes.bool.isRequired,
  allowPostingComments: PropTypes.bool.isRequired,
  onChangePostingContent: PropTypes.func.isRequired,
  onChangePostingComments: PropTypes.func.isRequired,
  stacked: PropTypes.bool,
}

export default ChildSocialFeatureSettings
